/* eslint-disable import/no-anonymous-default-export */
import businessServices from '../services/business'

const establishmentLogic = async (paremeters) => {
    const response = businessServices.establishmentService(paremeters);
    return response;
}

const moduleLogic = async (paremeters, businessId) => {
    const response = await businessServices.moduleService(paremeters, businessId);
    const data = response[1];
    for (var f = 0; f < data.length; f++) {
        let moduleOptions = [];
        let nameModule = "";
        for (var i = 0; i < data[f].length; i++) {
            if (data[f][i].masterId === 0) {
                nameModule = data[f][i].name.toLowerCase();
            } else {
                moduleOptions[i] = {
                    id: data[f][i].id ?? '',
                    masterId: data[f][i].masterId ?? '',
                    name: data[f][i].name ?? '',
                    icon: data[f][i].icon ?? '',
                    path: data[f][i].path ?? '',
                    order: data[f][i].order ?? '',
                }
            }
        }
        localStorage.setItem(nameModule, JSON.stringify(moduleOptions))
    }
    return response[0];
}

export default {
    establishmentLogic,
    moduleLogic
}
